<template>
  <div v-if="open" class="selection">
    <div class="selection__upper_part">
      <div class="selection__upper_part__title">
        {{ $t("avatarSelectionTitle") }}
      </div>
      <div class="selection__upper_part__subtitle">
        {{ $t(`avatarSelectionSubtitle${lab}`) }}
      </div>
    </div>
    <div class="selection__lower_part">
      <div class="selection__lower_part__avatars">
        <div
          class="selection__lower_part__avatars__avatar"
          v-for="avatar in avatars"
          :key="avatar.name"
        >
          <img
            class="selection__lower_part__avatars__avatar__image"
            :src="avatar.image"
          />
          <div
            class="selection__lower_part__avatars__avatar__button"
            @click="selectAvatar(avatar)"
          >
            {{ $t(`avatarSelection${avatar.name}`) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { loadAvatar } from "@/scenes/MyFirstScene";

export default {
  name: "AvatarSelectionComponent",
  data() {
    return {
      resolveDialog: null,
      selectionIcon_01: require("../assets/svgs/flechitas_orange.svg"),
      selectionIcon_02: require("../assets/svgs/Mouse_icon_orange.svg"),
      logoWhite: require("../assets/svgs/logoWhite.svg"),
      open: true,
      avatars: [
        {
          name: "Peter",
          image: require("../assets/images/avatars/Peter.png"),
        },
        {
          name: "Sophie",
          image: require("../assets/images/avatars/Sophie.png"),
        },
      ],
    };
  },
  computed: {
    lab() {
      return this.$store.getters.getCurrentLab;
    },
  },
  methods: {
    async selectAvatar(avatar) {
      this.open = false;
      await this.$store.dispatch("setSpinner", { loading: true });

      await loadAvatar(avatar.name);

      this.$root.$emit("openLanding");
      this.$store.dispatch("setSpinner", { loading: false });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>
<style lang="scss" scoped>
.selection {
  position: fixed;
  width: 100vw;
  height: 100vh;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 6;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .selection__upper_part {
    display: flex;
    flex-direction: column;
    align-items: center;

    .selection__upper_part__title {
      width: 100%;
      font-family: "Unna";
      font-style: normal;
      font-weight: 400;
      font-size: 60px;
      text-align: center;
      margin-top: 100px;

      color: #fffdfd;
    }

    .selection__upper_part__subtitle {
      width: 100%;
      font-size: 20px;
      font-family: "Calibre";
      font-style: normal;
      font-weight: 400;
      text-align: center;

      color: #ffffff;
    }
  }

  .selection__lower_part {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 1;
    justify-content: space-evenly;

    .selection__lower_part__avatars {
      display: flex;
      width: 100vw;
      align-items: flex-start;
      justify-content: space-evenly;

      .selection__lower_part__avatars__avatar {
        width: calc(50vw - 25px);
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 170px;
        margin: 0;

        .selection__lower_part__avatars__avatar__name {
          font-family: "Calibre";
          font-style: normal;
          font-weight: 600;
          font-size: 3vw;
          text-align: center;
          color: #ffffff;
          margin: 0;
        }

        .selection__lower_part__avatars__avatar__image {
          max-width: 100%;
          max-height: 50vh;
          object-fit: contain;
        }

        .selection__lower_part__avatars__avatar__button {
          font-style: normal;
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
          font-feature-settings: "pnum" on, "lnum" on;
          color: #333333;

          max-width: 100%;
          width: 200px;
          height: 43px;
          line-height: 46px;
          border-radius: 2px;
          border: 2px solid #333333;
          background-color: #ffffff;

          font-family: Calibre;
          font-size: 18px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-color: #fe5b1b;
            color: #fff !important;
            border: 2px solid #fe5b1b;
            transition: 0.2s;
          }
        }
      }
    }

    .selection__lower_part__button {
      width: 202px;
      height: 43px;
      padding: 12px 28px 11px 26px !important;
      border-radius: 2px;
      background-color: #fe5b1b;
      font-family: Calibre;
      font-size: 16px;
      text-align: center;
      color: #fff !important;
      cursor: pointer;

      &:hover {
        background-color: #fe791b;
        transition: 0.2s;
      }
    }
  }
}
</style>
